import "core-js/modules/es.array.find";
import _createForOfIteratorHelper from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/createSuper";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/commands/removecolumncommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import TableWalker from '../tablewalker';
import { findAncestor, updateNumericAttribute } from './utils';
/**
 * The remove column command.
 *
 * The command is registered by {@link module:table/tableediting~TableEditing} as `'removeTableColumn'` editor command.
 *
 * To remove the column containing the selected cell, execute the command:
 *
 *		editor.execute( 'removeTableColumn' );
 *
 * @extends module:core/command~Command
 */

var RemoveColumnCommand = /*#__PURE__*/function (_Command) {
  _inherits(RemoveColumnCommand, _Command);

  var _super = _createSuper(RemoveColumnCommand);

  function RemoveColumnCommand() {
    _classCallCheck(this, RemoveColumnCommand);

    return _super.apply(this, arguments);
  }

  _createClass(RemoveColumnCommand, [{
    key: "refresh",

    /**
     * @inheritDoc
     */
    value: function refresh() {
      var editor = this.editor;
      var selection = editor.model.document.selection;
      var tableUtils = editor.plugins.get('TableUtils');
      var tableCell = findAncestor('tableCell', selection.getFirstPosition());
      this.isEnabled = !!tableCell && tableUtils.getColumns(tableCell.parent.parent) > 1;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "execute",
    value: function execute() {
      var model = this.editor.model;
      var selection = model.document.selection;
      var firstPosition = selection.getFirstPosition();
      var tableCell = findAncestor('tableCell', firstPosition);
      var tableRow = tableCell.parent;
      var table = tableRow.parent;
      var headingColumns = table.getAttribute('headingColumns') || 0;
      var row = table.getChildIndex(tableRow); // Cache the table before removing or updating colspans.

      var tableMap = _toConsumableArray(new TableWalker(table)); // Get column index of removed column.


      var cellData = tableMap.find(function (value) {
        return value.cell === tableCell;
      });
      var removedColumn = cellData.column;
      model.change(function (writer) {
        // Update heading columns attribute if removing a row from head section.
        if (headingColumns && row <= headingColumns) {
          writer.setAttribute('headingColumns', headingColumns - 1, table);
        }

        var _iterator = _createForOfIteratorHelper(tableMap),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _step.value,
                cell = _step$value.cell,
                column = _step$value.column,
                colspan = _step$value.colspan;

            // If colspaned cell overlaps removed column decrease it's span.
            if (column <= removedColumn && colspan > 1 && column + colspan > removedColumn) {
              updateNumericAttribute('colspan', colspan - 1, cell, writer);
            } else if (column === removedColumn) {
              // The cell in removed column has colspan of 1.
              writer.remove(cell);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }]);

  return RemoveColumnCommand;
}(Command);

export { RemoveColumnCommand as default };